<!--
    描述：会员管理
    时间：2022-06-22
    Created by zwh
-->
<template>
	<div class="es-main operation-layout" :class="{ pd0: !routeQuery }">
		<!-- 列表查询页 -->
		<filter-layout @search="doSearch" @reset="resetSearch" v-if="!routeQuery">
			<template #filter>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchForm" label-width="110px">
					<el-form-item label="文件名称：" prop="fileName">
						<el-input :placeholder="'请输入'" clearable v-model="searchForm.fileName"> </el-input>
					</el-form-item>
					<el-form-item label="流程ID：" prop="flowId">
						<el-input :placeholder="'请输入'" clearable v-model="searchForm.flowId"> </el-input>
					</el-form-item>
				</el-form>
			</template>
			<template #content>
				<!-- 非请求参数 正常查看 -->
				<div class="operation-main">
					<div class="operation-header">
						<div class="title">
							合同合计：<span class="blue">{{ tableObj.total }}</span> 份
						</div>
						<div class="btnGroups"></div>
					</div>
					<div class="operation-container w-table-layout w-table-page">
						<div class="w-table-content" v-show="tableShow">
							<el-table ref="xTable" :data="tableObj.data" highlight-current-row height="100%" size="mini" border>
								<el-table-column type="index" label="" width="50" align="center"> </el-table-column>
								<el-table-column prop="fileName" label="文件名称" header-align="center" min-width="230" show-overflow-tooltip>
								</el-table-column>
								<el-table-column prop="sname" label="合同类型" align="center" width="180" show-overflow-tooltip></el-table-column>
								<el-table-column prop="idCard" label="业务信息" align="center" width="180" show-overflow-tooltip></el-table-column>
								<el-table-column prop="phone" label="业务数据" align="center" width="130" show-overflow-tooltip></el-table-column>
								<el-table-column prop="fileId" label="文件ID" width="180" align="center" show-overflow-tooltip></el-table-column>
								<el-table-column prop="flowId" label="流程ID" width="180" align="center" show-overflow-tooltip> </el-table-column>

								<el-table-column align="center" width="210">
									<template slot="header">操作</template>
									<template slot-scope="scope">
										<el-button
											type="primary"
											size="small"
											round
											plain
											class="table-btn"
											v-if="roleBtns.includes('contractView')"
											@click="showView(scope.row)"
										>
											<svg-icon icon-class="form-details"></svg-icon>
											查看合同
										</el-button>
										<el-button
											type="primary"
											size="small"
											round
											plain
											class="table-btn"
											v-if="roleBtns.includes('contractDetail')"
											@click="showDetail(scope.row)"
										>
											<svg-icon icon-class="form-details"></svg-icon>
											详情
										</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="w-table-footer">
							<el-pagination
								@size-change="handleSizeChange"
								@current-change="handleCurrentChange"
								:current-page="tableObj.currentPage"
								:page-sizes="tableObj.pageList"
								:page-size="tableObj.pageSize"
								:total="tableObj.total"
								layout="total, sizes, prev, pager, next, jumper"
							>
							</el-pagination>
						</div>
					</div>
				</div>
			</template>
		</filter-layout>

		<!-- 详情页 -->
		<template v-else>
			<memberDetail ref="memberDetail"></memberDetail>
		</template>

		<!-- 查看合同 -->
		<el-dialog
			:title="viewDialogObj.title"
			:visible.sync="viewDialogObj.visible"
			:width="viewDialogObj.width"
			:close-on-click-modal="false"
			@close="viewDialogClose"
			center
		>
			<!-- 弹窗组件 -->
			<div v-if="viewDialogObj.visible" style="height: 730px">
				<iframe :src="filePreViewUrl" style="height: 100%;width: 100%"></iframe>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import memberDetail from './components/detail'
import * as API from 'api/modules/es/es_file.js'
import { turnHump } from 'utils/tools.js'
export default {
	name: 'index',
	components: {
		memberDetail
	},
	data() {
		return {
			btnLoading: false,
			searchToggle: true,
			tableShow: true,
			searchForm: {
				fileName: '',
				flowId: ''
			},
			tableObj: {
				currentPage: 1, // 当前页码
				pageList: [10, 20, 50, 100], // 显示条数数组
				pageSize: 10, // 当前显示条数
				total: 0 // 当前总条数
			},

			startDatePicker: this.beginDate(),
			endDatePicker: this.processDate(),

			viewDialogObj: {
				title: '',
				visible: false,
				width: '600px',
				mode: 'add',
				stepIndex: 1
			},

			//附件预览地址
			filePreViewUrl: ''
		}
	},
	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
			setTimeout(() => {
				this.$refs.xTable.doLayout()
			}, 1000)
		}
	},
	computed: {
		...mapState('app', { isBack: (state) => state.isBack }),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns
		}),
		routeQuery() {
			return this.$route.query.type
		},
		// 预览环境变量
		previewUrl() {
			return process.env.VUE_APP_PREVIEW_URL
		}
	},
	created() {
		// 如果是 返回的
		if (this.isBack) {
			if (this.$getSessionItem('params')) {
				let params = JSON.parse(this.$getSessionItem('params'))
				Object.keys(this.searchForm).forEach((key) => (this.searchForm[key] = params[key]))
				this.tableObj.currentPage = params.currentPage
				this.tableObj.pageSize = params.pageSize

				// 移除 避免污染
				this.$removeSessionItem('params')
			}
		}
		this.getPageTableList()
	},
	methods: {
		//查询
		doSearch() {
			this.getPageTableList()
		},
		//获取分页列表信息
		getPageTableList() {
			this.tableObj.data = []
			let param = Object.assign({}, this.searchForm)
			;(param.current = this.tableObj.currentPage), (param.size = this.tableObj.pageSize)
			API.getPageTableList(param).then((res) => {
				if (res.operationCode == 1) {
					let data = res.data.records
					data = data.map((_row) => {
						return turnHump(_row)
					})
					this.tableObj.data = data
					this.tableObj.total = parseInt(res.data.total)
				}
			})
		},
		//按钮事件
		showView(row) {
			//this.filePreViewUrl = this.previewUrl + row.downUrl
			this.filePreViewUrl = 'https://pdf.52ngs.com/onlinePreview?url=' + row.downUrl
			this.viewDialogObj.title = row.fileName
			this.viewDialogObj.width = '1000px'
			this.viewDialogObj.visible = true
		},
		showDetail(row) {
			let params = Object.assign({}, this.searchForm)
			params.currentPage = this.tableObj.currentPage
			params.pageSize = this.tableObj.pageSize
			this.$setSessionItem('params', JSON.stringify(params))

			this.$router.push({
				name: 'Es-signed-contract-index',
				query: {
					type: 'contractDetail',
					id: row.id
				}
			})
		},

		viewDialogClose() {
			this.viewDialogObj.visible = false
		},

		//重置查询
		resetSearch() {
			Object.keys(this.searchForm).forEach((key) => (this.searchForm[key] = ''))
			this.tableObj.pageSize = 10
			this.tableObj.currentPage = 1
			this.getPageTableList()
		},
		//刷新
		reFresh() {
			Object.keys(this.searchForm).forEach((key) => (this.searchForm[key] = ''))
			this.tableObj.pageSize = 10
			this.tableObj.currentPage = 1
			this.getPageTableList()
		},
		// 切换显示条数
		handleSizeChange(val) {
			this.tableObj.pageSize = val
			this.getPageTableList()
		},

		//切换当前页码
		handleCurrentChange(val) {
			this.tableObj.currentPage = val
			this.getPageTableList()
		},
		// 是否展开搜索区域
		changeState() {
			this.searchToggle = !this.searchToggle
		},

		// 开始时间的 pickOption
		beginDate() {
			let that = this
			return {
				disabledDate(time) {
					let endTime = ''
					endTime = that.searchForm.endTime
					if (endTime) {
						return bmElementTimeOptins.limitDateBefore(time, endTime, true)
					} else {
						return time.getTime() > Date.now()
					}
				}
			}
		},

		// 结束时间的 pickOption
		processDate() {
			let that = this
			return {
				disabledDate(time) {
					let startTime = ''
					startTime = that.searchForm.startTime
					if (startTime) {
						let nowTime = Date.now()
						return bmElementTimeOptins.limitDateInRange(time, startTime, nowTime, true)
					} else {
						return time.getTime() > Date.now()
					}
				}
			}
		},
		// 返回
		goBack() {
			this.$router.push({ path: '/es-member-management-index' })
		}
	}
}
</script>

<style lang="less" scoped>
.operation-layout.pd0 {
	padding: 0;
}
.es-main {
	.filter-box {
		padding-top: 5px;
	}

	/deep/ .search-form {
		.el-form-item {
			margin-bottom: 5px;
		}
	}

	.blue-text {
		color: #2671cc;
		cursor: pointer;
	}

	.blue-text:hover {
		color: blue;
	}

	.el-switch.is-disabled {
		opacity: 1;
	}

	/deep/ .el-switch.is-disabled .el-switch__core,
	/deep/ .el-switch.is-disabled .el-switch__label {
		cursor: pointer !important;
	}
}
.w-table-content {
	/deep/ .el-radio__label {
		display: none;
	}
}
.label-tooltip {
	max-width: 600px;
	max-height: 140px;
	overflow-y: auto;
	overflow-x: hidden;
}

.primary-dialog {
	/deep/ .el-dialog__body {
		padding: 30px;
	}

	.row-label {
		height: 40px;
		line-height: 40px;
		padding-right: 15px;
	}

	.row-btn {
		padding-left: 10px;
		width: 100%;
	}

	.tags-container {
		line-height: 40px;
		max-height: 120px;
		overflow-y: auto;

		/deep/ .el-tag {
			cursor: pointer;
		}
	}

	.tags-all-container {
		line-height: 30px;
		max-height: 300px;
		overflow-y: auto;

		/deep/ .el-tag {
			cursor: pointer;
		}
	}
}
</style>

<style lang="less">
.status {
	.switch > .el-switch__label--right > span {
		margin-left: 0 !important;
		margin-right: 15px !important;
	}
}
</style>
